module.exports = __webpack_public_path__ + "img/bg-light.a6098eb5.jpg";